import { render, staticRenderFns } from "./adhocVehicleFreightApproval.vue?vue&type=template&id=6122b85c&scoped=true"
import script from "./adhocVehicleFreightApproval.vue?vue&type=script&lang=js"
export * from "./adhocVehicleFreightApproval.vue?vue&type=script&lang=js"
import style0 from "./adhocVehicleFreightApproval.vue?vue&type=style&index=0&id=6122b85c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6122b85c",
  null
  
)

export default component.exports